import { withInstall } from "../utils/index.mjs";
import _Checkbox from "./Checkbox.mjs";
const Checkbox = withInstall(_Checkbox);
var stdin_default = Checkbox;
import { checkboxProps } from "./Checkbox.mjs";
export {
  Checkbox,
  checkboxProps,
  stdin_default as default
};
